import alternativeJson from "./alternatives.json";

interface Alternatives {
  [key: string]: { [key: string]: string };
}

export const QUESTION_1 = "question_1";
export const QUESTION_2 = "question_2";
export const QUESTION_3 = "question_3";
export const QUESTION_4 = "question_4";

export type QuestionIdentifierType = "question_1" | "question_2" | "question_3" | "question_4";

const parseRecommentaions = (recommendatinos: any) => {
  return recommendatinos.map((item: any) => (
    {
      name: item.name.trim(),
      price: item.price,
      remark: item.remark
    }
  ))
}

const normalizeString = (valueString: string) => {
  if (valueString) {
    valueString = valueString.replace(/ñ/gi, 'n');
    valueString = valueString.toLowerCase();
    valueString = valueString.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
    return valueString;
  }
  return "";
}

const parseAlternatives = (value: string, questionIdentifier: keyof typeof alternativeJson): string | undefined => {
  const alternatives = alternativeJson[questionIdentifier];
  if (!alternatives) return undefined;

  for (const [key, val] of Object.entries(alternatives)) {
    if (val === value) {
      return key;
    }
  }
  return undefined;
}

export const parseAnswersGTM = (answers: any, questionIdentifier: QuestionIdentifierType):string => {
  let alternativesSelected:any = "";
  for (let i = 0; i < answers.length; i++) {
    if (answers[i].id_question === parseInt(questionIdentifier.split("question_")[1])) {
      if (Array.isArray(answers[i].alternative_text)) {
        alternativesSelected = answers[i].alternative_text.map((item: any) => {
          return parseAlternatives(item, questionIdentifier);
        }).join(" / ");
      } else {
        alternativesSelected = parseAlternatives(answers[i].alternative_text, questionIdentifier);
      }
    }
  }

  return alternativesSelected;
};

export {
  parseRecommentaions,
  normalizeString,
  parseAlternatives
}